import React, {useEffect, useState} from 'react';
import {YourCartProps} from "../../@types/cart";
import ButtonPrimary from "../Form/Button/ButtoPrimary";

const YourBottomCart: React.FC<YourCartProps> = ({ cart, onSignup, onChangeAddress, buttonText, isLoading, hideButton, onValidated }) => {

  const [isVisible, setIsVisible] = useState<boolean>(false);

  const payMonthly = cart?.products?.filter((product) => product.isMonthly);
  const payToday = cart?.products?.filter((product) => !product.isMonthly && product.cost > 0);

  const hasPlan = cart?.products?.find((product) => product.type === 'PLAN') !== undefined;
  const hasRouter = cart?.products?.find((product) => product.type === 'ROUTER') !== undefined;
  const termedItem = cart?.products?.find((product) => product.type === 'ROUTER' && product.months > 0);

  const toggleCart = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    if (onValidated) {
      onValidated(hasPlan && hasRouter);
    }
  }, [hasPlan, hasRouter, onValidated]);

  return (
      <div className="w-full bg-white">
        <div className='px-4 bg-fred-blue-500 flex justify-between items-center'>
          <h3 className="text-2xl text-left py-4 font-medium text-white w-1/3">Your Cart</h3>
          <div className="w-1/3 flex justify-center">

          </div>
          <div className="w-1/3 flex justify-end" onClick={toggleCart}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                 stroke="currentColor" className="w-12 h-12 text-white cursor-pointer">
              {!isVisible ? (
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
              ) : (
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
              )
              }
            </svg>
          </div>
        </div>
        <div className={`${!isVisible ? 'hidden' : 'block'} mt-2`}>
          <div className="p-4 space-y-4">
            <div className=''>
              <h5 className='mb-1 text-xl font-medium'>Your Address</h5>
              <p className='text-base'>{cart?.address?.fullAddress}</p>
              <p>
                <span className="font-bold underline cursor-pointer" onClick={() => onChangeAddress()}>CHANGE</span>
              </p>
            </div>
            <div>
              <h5 className='text-xl font-medium'>Products</h5>
              <div className="flex flex-col w-full space-y-1 mt-2">
                {!cart?.products && (
                    <p className='text-base font-normal'>No products selected</p>
                )}
                {cart?.products && cart.products.filter((product) => product.type === 'PLAN').map((product) => {
                  return (
                      <p key={product.productId}
                         className='text-base'>{`${product.productName}${termedItem ? ` (${termedItem.months}-month term)` : ''}`}</p>
                )
                })}
                {cart?.products && cart.products.filter((product) => product.type === 'ROUTER').map((product) => {
                  return (
                      <p key={product.productId} className='text-base'>{product.productName}</p>
                  )
                })}
              </div>
            </div>
            {(payMonthly && payMonthly.length > 0) && (
                <div>
                  <h5 className='text-xl font-medium mb-2'>Monthly Payment</h5>
                  {payMonthly.map((product) => {
                    return (
                        <div>
                          <div key={product.productId} className='flex items-center justify-between space-y-1'>
                            <p className='text-base'>{product.productName}</p>
                            <p className='text-base'>${product.cost ? product.cost / 100 : 0}</p>
                          </div>
                        </div>
                    )
                  })}
                  <div className='flex justify-between items-center mt-2'>
                    <p className='text-base font-normal text-fred-purple-500'>Monthly Total</p>
                    <p className='text-3xl font-semibold text-fred-purple-500'>${payMonthly.reduce((sum, product) => sum + (product.cost / 100), 0)}</p>
                  </div>
                </div>
            )}
            {(payToday && payToday.length > 0) && (
                <div>
                  <h5 className='text-xl font-medium mb-2'>One-off Payment</h5>
                  {payToday.map((product) => {
                    return (
                        <div key={product.productId} className='flex items-center justify-between space-y-1'>
                          <p className='text-base'>{product.productName}</p>
                          <p className='text-base'>${product.cost ? product.cost / 100 : 0}</p>
                        </div>
                    )
                  })}
                  <div className='flex justify-between items-center mt-2'>
                    <p className='text-base font-normal text-fred-purple-500'>One-off Total</p>
                    <p className='text-3xl font-semibold text-fred-purple-500'>${payToday.reduce((sum, product) => sum + (product.cost / 100), 0)}</p>
                  </div>
                </div>
            )}
            {(cart?.promoCode) && (
                <div className="space-y-2 border-t-2 border-b-2 border-dashed border-green-500 py-2">
                  <h5 className='text-xl font-medium'>Promo Code</h5>
                  <div className='flex items-center text-green-800 gap-x-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" className="flex-shrink-0 inline w-5 h-5 text-green-800">
                      {hasPlan ?
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/> :
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                      }
                    </svg>
                    <p className='text-base font-bold text-green-800'>{cart.promoCode.code}</p>
                  </div>
                </div>
            )}
          </div>
          <div className='px-4'>
            <p className="text-sm italic">All prices are inclusive of GST</p>
          </div>
          <div className='p-4 flex justify-between gap-x-4'>
            <div
                className={`w-1/2 flex items-center p-2 text-sm rounded-lg ${hasPlan ? 'text-green-800 bg-green-50' : 'text-red-800 bg-red-50'}`}
                role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" className="flex-shrink-0 inline w-5 h-5 me-2">
                {hasPlan ?
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/> :
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                }
              </svg>
              <div>
                <span className="font-medium">Base plan</span>
              </div>
            </div>
            <div
                className={`w-1/2 flex items-center p-2 text-sm rounded-lg ${hasRouter ? 'text-green-800 bg-green-50' : 'text-red-800 bg-red-50'}`}
                role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" className="flex-shrink-0 inline w-5 h-5 me-2">
                {hasRouter ?
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/> :
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                }
              </svg>
              <div>
                <span className="font-medium">Router</span>
              </div>
            </div>
          </div>
          {!hideButton && (
              <div className='p-4 flex justify-center'>
                <ButtonPrimary text={buttonText ? buttonText : 'Sign Up Now'}
                               disabled={!hasPlan || !hasRouter || isLoading} onClick={() => onSignup?.()}/>
              </div>
          )}
        </div>
      </div>
  );
};

export default YourBottomCart;
